import { api } from "services";
import { resToImage } from ".";

import { Image } from "./types";

export const getImageFile = async (id: number): Promise<File> => {
  const resp = await api.get(`images/${id}`, { responseType: "arraybuffer" });
  return new File([resp.data], "Test");
};

export const postImage = async (formData: FormData): Promise<Image> => {
  const resp = await api.post(`images`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return resToImage(resp.data);
};
